import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../services/auth-guard.service';
import { Roles } from '../models/roles.model';

// Route for content layout with sidebar, navbar and footer
export const Full_ROUTES: Routes = [
  {
    path: 'developer',
    data: { roles: [Roles.Developer] },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../../developer/developer.module').then((m) => m.DeveloperModule),
  },
  {
    path: 'admin',
    data: { roles: [Roles.Administrator] },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../../admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'network',
    data: { roles: [Roles.Network] },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../../network/network.module').then((m) => m.NetworkModule),
  },
  {
    path: 'mockups',
    loadChildren: () =>
      import('../../mockups/mockups.module').then((m) => m.MockupsModule),
  },
];
